import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Box, Grid } from '@dhl-ui/components'
import { BackButton } from '~/temp-ds-component/BackButton'

import { links } from '~/AppRoutes'
import { Organisations, BillingunitDetails } from '~/modules/billingunits/components'

export const BillingunitDetailsPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const onBack = () => navigate(links.billingUnitsLink())

  return (
    <>
      <Box p={2}>
        <Box display="flex" justifyContent="space-between" pb={2}>
          <BackButton onClick={onBack}>{t('admin.billingUnitsPage.backButton')}</BackButton>
        </Box>
        <Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <BillingunitDetails />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Organisations />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  )
}
